import React, { useEffect, useState } from 'react'
import { Alert, Button } from '@mui/material'
import { isLocalStorageAvailable } from '../../utils/storage'
import { Trans, useTranslation } from 'translations'

const DO_NOT_SHOW_WARNING_KEY_NAME = 'doNotShowRtpSettingsWarning'
export const DoNotEditSettingsWarningMessage = () => {
    const { t } = useTranslation()
    const [doNotShowRtpSettingsWarning, setDoNotShowRtpSettingsWarning] = useState<boolean | null>(null)
    const [showWarning, setShowWarning] = useState<boolean>(true)
    const [doNotShowAgainButtonHidden, setDoNotShowAgainButtonHidden] = useState<boolean>(false)

    useEffect(() => {
        if (isLocalStorageAvailable()) {
            if (localStorage.getItem(DO_NOT_SHOW_WARNING_KEY_NAME) === null) {
                setDoNotShowRtpSettingsWarning(false)
            } else {
                setDoNotShowRtpSettingsWarning(JSON.parse(localStorage.getItem(DO_NOT_SHOW_WARNING_KEY_NAME) as string))
            }
        } else {
            setDoNotShowAgainButtonHidden(true)
            setDoNotShowRtpSettingsWarning(false)
        }
    }, [])

    useEffect(() => {
        if (isLocalStorageAvailable()) {
            localStorage.setItem(DO_NOT_SHOW_WARNING_KEY_NAME, `${doNotShowRtpSettingsWarning}`)
        }
    }, [doNotShowRtpSettingsWarning])

    if (doNotShowRtpSettingsWarning === true || !showWarning) {
        return null
    }

    return (
        <Alert
            severity="warning"
            onClose={() => setShowWarning(false)}
            data-testid="do-not-edit-settings-warning-message"
        >
            <Trans
                i18nKey="globalPricingSettings.studio.doNotEditWarning.text"
                components={{ anchor: <a href="mailto:support@convious.com" /> }}
            />
            {!doNotShowAgainButtonHidden && (
                <div className="actions">
                    <Button
                        style={{ float: 'right' }}
                        size="small"
                        variant="text"
                        onClick={() => setDoNotShowRtpSettingsWarning(true)}
                    >
                        {t('globalPricingSettings.studio.doNotEditWarning.doNotShowAgain')}
                    </Button>
                </div>
            )}
        </Alert>
    )
}
